import React, { useState } from 'react';
import { useTranslation } from '@wix/cli-i18n';
import { useProjectModel } from '../../../model.js';
import { generateDashboardPage } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import {
  AddToCategoryStep,
  ChooseCategoryStep,
  RouteStep,
  TitleStep,
} from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateDashboardPage = () => {
  const { t } = useTranslation();
  const { model } = useProjectModel();
  const extensionType = t('generate_command.flow.dashboard_page').toLowerCase();

  const categories = model.config.dashboard?.sidebar?.categories ?? [];
  const categoriesExist = Boolean(categories.length);

  const [pageTitle, setPageTitle] = useState<string>();
  const [pageRoute, setPageRoute] = useState<string>();
  const [addToCategory, setAddToCategory] = useState<boolean>();
  const [sidebarCategory, setSidebarCategory] = useState<string>();

  const pageQuestionsAnswered = pageRoute && pageTitle;
  const addingSidebarCategory =
    categoriesExist && addToCategory && sidebarCategory;
  const notAddingSidebarCategory = !categoriesExist || addToCategory === false;

  const generationTask = useGenerationTask(async () => {
    if (!pageQuestionsAnswered) {
      return;
    }

    if (addingSidebarCategory) {
      return generateDashboardPage(
        model.projectFolder,
        pageRoute,
        pageTitle,
        sidebarCategory
      );
    }

    return generateDashboardPage(model.projectFolder, pageRoute, pageTitle);
  }, [
    pageQuestionsAnswered,
    notAddingSidebarCategory || addingSidebarCategory,
  ]);

  return [
    <TitleStep pageTitle={pageTitle} onSubmit={setPageTitle} />,
    <RouteStep
      pageTitle={pageTitle}
      pageRoute={pageRoute}
      onSubmit={setPageRoute}
    />,
    ...(categoriesExist
      ? [
          <AddToCategoryStep
            value={addToCategory}
            onSubmit={setAddToCategory}
          />,
          <ChooseCategoryStep onSubmit={setSidebarCategory} />,
        ]
      : []),
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={extensionType}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        learnMoreUrl: 'https://wix.to/7W3nYUg',
      })}
      route={pageRoute}
    />,
  ];
};
